/**
 * groupEntities selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import groupBy from 'lodash.groupby';
import isEqual from 'lodash.isequal';

// Selectors
import { selectCurrentEntityId } from '../currentEntityId/selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectGroupEntities = state => state.groupEntities;
const selectGroupId = (state, { groupId }) => groupId && Number(groupId);
const selectEntityId = (state, { entityId }) => entityId && Number(entityId);

const selectData = createDeepEqualSelector(
    selectGroupEntities,
    groupEntitiesState => groupEntitiesState
);

const selectDataGroupedByGroupId = createDeepEqualSelector(
    selectGroupEntities,
    groupEntitiesState => groupBy(groupEntitiesState, 'groupId')
);

const selectDataGroupedByEntityId = createDeepEqualSelector(
    selectGroupEntities,
    groupEntitiesState => groupBy(groupEntitiesState, 'entityId')
);

const selectGroupData = createDeepEqualSelector(
    [selectDataGroupedByGroupId, selectGroupId],
    (dataGroupedByGroupIdState, groupIdState) =>
        dataGroupedByGroupIdState && dataGroupedByGroupIdState[groupIdState]
);

const selectEntityData = createDeepEqualSelector(
    [selectDataGroupedByEntityId, selectEntityId],
    (dataGroupedByEntityIdState, entityIdState) =>
        dataGroupedByEntityIdState && dataGroupedByEntityIdState[entityIdState]
);

const makeSelectGroupEntitiesIds = () =>
    createDeepEqualSelector(
        selectGroupData,
        groupDataState =>
            groupDataState && groupDataState.map(value => value.entityId)
    );

const makeSelectEntityGroupIds = () =>
    createDeepEqualSelector(
        selectEntityData,
        entityDataState =>
            entityDataState && entityDataState.map(value => value.groupId)
    );

const selectCurrentEntityData = createDeepEqualSelector(
    [selectDataGroupedByEntityId, selectCurrentEntityId],
    (dataGroupedByEntityIdState, currentEntityIdState) => {
        if (!currentEntityIdState) return undefined;
        return dataGroupedByEntityIdState[currentEntityIdState] || [];
    }
);

const selectCurrentEntityGroupIds = createDeepEqualSelector(
    selectCurrentEntityData,
    entityDataState =>
        entityDataState && entityDataState.map(value => value.groupId)
);

export {
    selectGroupEntities,
    selectData,
    selectDataGroupedByGroupId,
    selectDataGroupedByEntityId,
    selectGroupData,
    selectEntityData,
    makeSelectGroupEntitiesIds,
    makeSelectEntityGroupIds,
    selectCurrentEntityData,
    selectCurrentEntityGroupIds
};
